import React from "react";

const TextInput = ({
  value,
  onChange,
  placeholder = "Metin girin...",
  label,
  required = false,
  error = false,
  errorMessage = "",
  className = "",
  wrapperClassName = "",
  type = "text",
  endAdornment = null,
  labelClassName = "",
  ...props
}) => {
  return (
    <div className={`space-y-2 ${wrapperClassName}`}>
      {label && (
        <label
          className={`block text-sm font-semibold text-gray-700 ${labelClassName}`}
        >
          {label}
          {required && <span className="text-red-500 ml-1">*</span>}
        </label>
      )}
      <div className="relative">
        <input
          type={type}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          className={`w-full px-4 py-3 bg-white border border-gray-200 rounded-2xl text-gray-800 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-300 shadow-sm hover:shadow-md ${
            error ? "border-red-300" : ""
          } ${endAdornment ? "pr-12" : ""} ${className}`}
          {...props}
        />
        {endAdornment && (
          <div className="absolute inset-y-0 right-0 flex items-center pr-2">
            {endAdornment}
          </div>
        )}
      </div>
      {error && errorMessage && (
        <p className="text-red-500 text-xs mt-1">{errorMessage}</p>
      )}
    </div>
  );
};

export default TextInput;
